import { useTranslation } from 'react-i18next';

import type { Client } from '~/api/clients/types';
import type { SubmittedInvoice } from '~/api/invoices/types';

import { Text, Title } from '~/components';
import { creativeShelter } from '~/constants/creativeShelter';

import { CoInvoiceCard } from './CoInvoiceCard';
import { FcInvoiceCard } from './FcInvoiceCard';
import { cardsStyle, introStyle, sectionStyle } from './InvoiceSplit.css';

type Props = {
  client: Client;
  invoice: SubmittedInvoice;
  onDownload: () => void;
  onPreview: () => void;
};

export const InvoiceSplit = ({ client, invoice, onDownload, onPreview }: Props) => {
  const { t } = useTranslation(['invoices']);

  const showCoInvoice = client.vatNumber !== creativeShelter.vatNumber;

  return (
    <section className={sectionStyle}>
      <div className={introStyle}>
        <Title as="h2" styleAs="h3">
          {t('invoices:details.split.title')}
        </Title>

        <Text>{t('invoices:details.split.description')}</Text>
      </div>

      <div className={cardsStyle}>
        <FcInvoiceCard invoice={invoice} onDownload={onDownload} />

        {showCoInvoice && <CoInvoiceCard client={client} invoice={invoice} onPreview={onPreview} />}
      </div>
    </section>
  );
};
